import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LobbyConfigRepository } from "./config-repository.service";
import { GetConfigUseCase } from "./get-config.use-case";
import { LOBBY_CONFIG_REPOSITORY_TOKEN } from "./interfaces";


@NgModule({
    declarations: [],
    providers: [
        LobbyConfigRepository,
        GetConfigUseCase,
        { provide: LOBBY_CONFIG_REPOSITORY_TOKEN, useClass: LobbyConfigRepository }
    ],
    imports: [
        CommonModule
    ]
})
export class ConfigModule {
}
